import React, { Fragment, useEffect, useLayoutEffect, useState } from "react";
import Booking from "./Booking";
import Popularplace from "./Popularplace";
import Features from "./Features";
import FAQ from "./FAQ";
import CricbuddyAppComp from "../NewLandingPage/CricbuddyAppComp";
import HelmetMetaTag from "../Utils/HelmetMetaTag/HelmetMetaTag";
import { CustomGetAPI } from "../Utils/APIConnector";
import { useNavigate } from "react-router-dom";
import Popup from "../LiveScoreCardpopups/Popup";
import VenueSearch from "../VenueListing/venueSearch";
import NewVenueSearch from "../VenueListing/NewVenueSearch";
import { handleLocationClick } from "../Utils/common";

export default function Index() {
  const [state, setState] = useState(
    window.localStorage.getItem("userLocation")
  );
  const [show, setShow] = useState({
    popup: false,
    sport: "all",
    event: true,
  });
  const [packageData, setPacakgeData] = useState();
  const data = (data) => {
    setState(data);
  };
  const userLocation = localStorage.getItem("userLocation")?.split("-")[
    localStorage.getItem("userLocation")?.split("-")?.length - 1
  ];
  useLayoutEffect(() => {
    CustomGetAPI(
      `/Packages/PackageByID/0/0?cityname=${userLocation && userLocation}`
    ).then((result) => {
      result = JSON.parse(result);
      if (result && result?.status == "Success") {
        setPacakgeData(result?.packages[0]);
      }
    });
  }, [userLocation]);

  const navigate = useNavigate();

  const handleSetShow = () => setShow({...show, popup: !show.popup})

  return (
    <Fragment>
      <HelmetMetaTag
        titleName="CricBuddy | Discover and Book Sports Venues near you Online"
        desc="Find the best sports complexes and venues near your area online & book instantly with CricBuddy. Search for matches happening nearby and join in."
        canonical={window.location.href}
        ogtitle="CricBuddy | Discover and Book Sports Venues near you Online"
        ogdesc="Find the best sports complexes and venues near your area online & book instantly with CricBuddy. Search for matches happening nearby and join in."
        ogtype="website"
        ogurl={window.location.href}
        ogimg="https://cricbuddy.in/logo192.png"
      />
      {/* <div className="px-0 row" style={{ overflowX: "hidden" }}> */}
      <div style={{ backgroundColor: "#FFFCFC", overflowX: "hidden" }}>
        <Booking data={data} />
        <Popularplace data={state} />
        {/* <div className="row mt-3 position-relative">
          <img
            src="/images/PackageBanner.jpg"
            className="img-fluid AuditoriumBaneerBgImg"
            alt=""
          />
          <div className="position-absolute auditoriumBannerText">
            <p
              style={{
                margin: "0px",
                color: "white",
              }}
            >
              {packageData ? (
                <span style={{ color: "#FFF200" }}>Play More, Pay Less:</span>
              ) : (
                <span style={{ color: "#FFF200" }}>
                  {userLocation
                    ? userLocation?.charAt(0)?.toUpperCase() +
                      userLocation?.slice(1)?.toLowerCase()
                    : "Ahmedabad"}
                  , prepare for savings!
                </span>
              )}
              <br />
              {packageData ? (
                <>
                  {packageData?.packageDuration} Hours of Box Cricket for ₹
                  {packageData?.price}
                </>
              ) : (
                <>Our package plan offer is coming soon.</>
              )}
            </p>
            <button
              className="mt-3 auditoriumBannerBtn px-3 py-1 fw-600"
              style={{
                color: "#E7666A",
                background: "#FFFFFF",
                border: "none",
                padding: "3px 5px",
                marginTop: "15px",
                borderRadius: "3px",
              }}
              onClick={() => {
                window.location.href = "/packages";
                // if (userLocation) {
                //   navigate(
                //     `/venue-search/${userLocation.toLocaleLowerCase()}/events/auditorium`
                //   );
                // } else {
                //   setShow({ popup: true, sport: "auditorium", event: true });
                // }
              }}
            >
              Know more
            </button>
          </div>
        </div> */}
        <div className="row px-md-5 px-2 position-relative mt-3 mt-md-4 gap-4 gap-md-0">
          <div className="col-md-6 position-relative">
            <img
              src="/images/PackageBanner_2.png"
              // className="img-fluid AuditoriumBaneerBgImg"
              className="img-fluid w-100"
              alt=""
            />
            {/* <div className="position-absolute auditoriumBannerText"> */}
            <div className="position-absolute auditoriumBannerText-new">
              <p
                style={{
                  margin: "0px",
                  color: "white",
                }}
              >
                {packageData ? (
                  <span
                    className="font-22 font-medium"
                    style={{ color: "#FFF200" }}
                  >
                    Play More, Pay Less:
                  </span>
                ) : (
                  <span style={{ color: "#FFF200" }}>
                    {userLocation
                      ? userLocation?.charAt(0)?.toUpperCase() +
                        userLocation?.slice(1)?.toLowerCase()
                      : "Ahmedabad"}
                    , prepare for savings!
                  </span>
                )}
                <br />
                {packageData ? (
                  <>
                    {packageData?.packageDuration} Hours of Box Cricket for ₹
                    {packageData?.price}
                  </>
                ) : (
                  <>Our package plan offer is coming soon.</>
                )}
              </p>
              <button
                className="mt-3 auditoriumBannerBtn px-3 py-2 fw-600"
                style={{
                  color: "#E7666A",
                  background: "#FFFFFF",
                  border: "none",
                  padding: "3px 5px",
                  marginTop: "15px",
                  borderRadius: "3px",
                }}
                onClick={() => {
                  navigate(`/packages`);
                }}
              >
                Know more
              </button>
            </div>
          </div>
          {/* {(userLocation == "ahmedabad" || !userLocation) && ( */}
            <div className="col-md-6 position-relative">
              <img
                src="/images/AuditoriumBaner_2.png"
                // className="img-fluid AuditoriumBaneerBgImg"
                className="img-fluid w-100"
                alt=""
                style={{borderRadius: '8px'}}
              />
              {/* <div className="position-absolute auditoriumBannerText"> */}
              <div className="position-absolute auditoriumBannerText-new">
                <p
                  style={{
                    margin: "0px",
                    color: "white",
                  }}
                >
                  Looking for a small Auditorium to organize <br /> or host an
                  event?
                </p>
                <button
                  className="mt-3 auditoriumBannerBtn px-3 py-2 fw-600"
                  style={{
                    color: "#E7666A",
                    background: "#FFFFFF",
                    border: "none",
                    padding: "3px 5px",
                    marginTop: "15px",
                    borderRadius: "3px",
                  }}
                  onClick={() => {
                    if(!userLocation){
                      setShow({ popup: true, sport: 'all' })
                      // handleLocationClick(true, "all", navigate, handleSetShow, userLocation)
                    } else {
                      navigate(`/venue-search/${userLocation}/events/all`);
                    }
                  }}
                >
                  Book Auditorium
                </button>
              </div>
            </div>
          {/* )} */}
        </div>
        <Features />
        <CricbuddyAppComp />
        <FAQ />
      </div>
      <Popup
        show={show?.popup}
        onHide={() => setShow({ popup: false, sport: "all" })}
      >
        {/* <VenueSearch isevent={"true"} sport={show?.sport} /> */}
        <NewVenueSearch isevent={"true"} sport={show?.sport} />
      </Popup>
      {/* </div> */}
    </Fragment>
  );
}
